<!-- add margin for qtweb-->
<div class="signin-wrapper" *ngIf="dataLoaded" [style.margin]="isUnusualBrowser() ? '40px auto': ''" role="main">
  <a class="signin-logo d-block mt-2 mb-4" href="http://www.pb.com"></a>

  <div class="signin-box">
    <!--rendered the translations from validateToken() method -->
    <h2 class="mt-0">{{name}}</h2>
    <div [translate]="'CLAIM_ACCOUNT_PAGE.USERNAME_IS'">Your Pitney Bowes username is</div>
    <div class="text-medium-blue"> {{username}}</div>
    <br/>
    <div [translate]="'CLAIM_ACCOUNT_PAGE.CREATE_PASSWORD_BELOW'">Create your password below </div>
    <br/>
    <div *ngIf="isCookieEnabled == false" class="alert alert-danger" [translate]="'GENERAL.NO_COOKIE_SUPPORT_MSG'">For your security, this application uses cookies for sign in. You’ll need to enable cookies in your browser’s settings.<a href="https://www.whatismybrowser.com/guides/how-to-enable-cookies/auto" target="_blank" [translate]="'GENERAL.LEARN_HOW'">Learn How</a></div>
    <form (ngSubmit)="onSubmit(claimAccountForm.get('newPassword').value, claimAccountForm.get('confirmPassword').value)" [formGroup]="claimAccountForm">
      <div *ngIf= "errorCode != '-1'" [ngClass]="errorCode != '-1' ? 'alert alert-danger mt-3' : ''">
        <div [ngSwitch]="errorCode">
          <div *ngSwitchCase="'PB-APIM-ERR-1000'">
            <span [translate]="'ERROR_MESSAGE.AUTH_ERROR.USER_DNE'">User does not exist</span>
          </div>
          <div *ngSwitchCase="'PB-APIM-ERR-0019'">
            <span [translate]="'ERROR_MESSAGE.AUTH_ERROR.SERVER_ISSUE'">Invalid password reset token</span>
          </div>
          <div *ngSwitchCase="'PB-APIM-ERR-0014'">
            <span [translate]="'ERROR_MESSAGE.AUTH_ERROR.USER_DNE'">User does not exist</span>
          </div>
          <div *ngSwitchCase="'PB-LOGIN-ERR-0001'">
            <span [translate]="'RESET_PASSWORD_PAGE.RESEND_FORGOT_PASSWORD_EMAIL'">The email link you have tried to use is no longer valid. Please enter your username to send a new link.
            </span>
          </div>
          <div *ngSwitchCase="0">
            <span [translate]="'ERROR_MESSAGE.AUTH_ERROR.SERVER_ISSUE'">We are having an issue with our server. Try again in a few minutes.</span>
          </div>
          <div *ngSwitchDefault [translate]="'ERROR_MESSAGE.AUTH_ERROR.SERVER_ISSUE'">We are having an issue with our server. Try again in a few minutes.</div>
          <span *ngSwitchDefault [translate]="'ERROR_PAGE.TRY_RELOADING'">In the meantime you can try reloading the page.</span>
        </div>
      </div>
      <div class="form-group">
        <label for="newPassword" [translate]="'GENERAL.PASSWORD'">Password</label>
        <div class="inner-addon">
          <input type="password" class="form-control" [ngClass]="{'is-invalid': newPassword.invalid && newPassword.touched}"
           [formControl]="newPassword" id="newPassword">
          <a class="small" href="javascript:void(0)" (click)="togglePasswordField('passwordHidden1', 'newPassword');">
            <span *ngIf="passwordHidden1" [translate]="'GENERAL.SHOW'">Show</span>
            <span *ngIf="!passwordHidden1" [translate]="'GENERAL.HIDE'">Hide</span>
          </a>
          <div class="invalid-feedback"
             *ngIf="newPassword.hasError('required') && newPassword.touched"
             [translate]="'ERROR_MESSAGE.PASSWORD_REQUIRED'">Password is required.
          </div>
          <div class="invalid-feedback"
            *ngIf="newPassword.hasError('maxlength')"
            [translate]="'ERROR_MESSAGE.VALID_PASSWORD'">Enter a valid password.
          </div>
        </div>
        <br/>

        <!-- Info/Danger Alert -->
        <div role="alert" class="alert alert-info">
          <p [translate]="'RESET_PASSWORD_PAGE.MUST_INCLUDE'">Your password must include at least:</p>
          <ul class="list-unstyled">
            <li>
              <em class="pbi-icon-mini pbi-delete-small" [ngClass]="showIcon(newPassword, 'minlength')"></em>
              <span [translate]="'RESET_PASSWORD_PAGE.EIGHT_CHARACTERS'">8 characters</span>
            </li>
            <li>
              <em class="pbi-icon-mini pbi-delete-small" [ngClass]="showIcon(newPassword, 'oneUppercase')"></em>
              <span [translate]="'RESET_PASSWORD_PAGE.ONE_UPPERCASE_LETTER'">1 uppercase letter</span>
            </li>
            <li>
              <em class="pbi-icon-mini pbi-delete-small" [ngClass]="showIcon(newPassword, 'oneDigitOrSpecialChar')"></em>
              <span [translate]="'RESET_PASSWORD_PAGE.DIGIT_OR_SPECIAL_CHARACTER'">1 digit or special character</span>
            </li>
          </ul>
        </div>
        <label for="confirmPassword" [translate]="'RESET_PASSWORD_PAGE.CONFIRM_PASSWORD'">Confirm password</label>
          <div class="inner-addon">
            <input type="password" class="form-control" [ngClass]="{'is-invalid': (confirmPassword.invalid && confirmPassword.touched) || claimAccountForm.hasError('nomatch') }"
              [formControl]="confirmPassword" id="confirmPassword">
            <a class="small" href="javascript:void(0)" (click)="togglePasswordField('passwordHidden2', 'confirmPassword');">
              <span *ngIf="passwordHidden2" [translate]="'GENERAL.SHOW'">Show</span>
              <span *ngIf="!passwordHidden2" [translate]="'GENERAL.HIDE'">Hide</span>
            </a>
          <div class="invalid-feedback"
             *ngIf="confirmPassword.hasError('required') && confirmPassword.touched"
             [translate]="'ERROR_MESSAGE.PASSWORD_CONFIRMATION_REQUIRED'">Password confirmation is required.
          </div>
          <div class="invalid-feedback" *ngIf="claimAccountForm.hasError('nomatch')" [translate]="'ERROR_MESSAGE.PASSWORD_MISMATCH'">
              Passwords do not match
          </div>
      </div>
      </div>
      <button [attr.disabled]="disableForm ? true: null" class="btn btn-primary btn-block btn-lg mt-2 mb-4"
        type="submit" [translate]="'CLAIM_ACCOUNT_PAGE.COMPLETE_REGISTRATION'" id="claimAccountButton">Complete My Registration</button>

    </form>
  </div>
  <!-- // end white box -->
</div>
